import React, { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useParams } from "react-router-dom";

import { useMobileHomeTaskList } from "./store";
import { fourPlaceHolder } from "modules/utilities/utility";
import AppHome from "assets/svgs/app_home";
import UserComponent from "./UserComponent";
import MasterComponent from "./MasterComponent";

function MobileTaskList() {
  const [show, setShow] = useState(false);
  const {
    allComponentData,
    componentLoading,
    segmentData,
    segmentLoading,
    fetchAllComponentData,
    fetchAllSegmentData,
  } = useMobileHomeTaskList();

  const { id } = useParams();
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    fetchAllSegmentData(id);
    fetchAllComponentData();
  };

  return (
    <>
      <div variant="primary" className="">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Mobile Home View</div>
              </Tooltip>
            }
          >
            <div
              className="d-flex text-primary cursor-pointer"
              onClick={handleShow}
            >
              <AppHome />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "70%" }}
        placement="end"
      >
        <Offcanvas.Header
          closeButton
          className="bg-light"
          style={{ zIndex: "999" }}
        >
          <Offcanvas.Title className="mb-n2">
            <div>
              <div className="">
                <span className="text-primary fw-bold">Mobile Task List</span>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="mt-n3">
          {componentLoading || segmentLoading ? (
            fourPlaceHolder()
          ) : (
            <div className="d-flex justify-content-between h-100">
              <div className="w-50">
                <UserComponent segmentData={segmentData} />
              </div>
              <div
                className="border mx-2 fw-bold"
                style={{ borderColor: "#7C7C7C" }}
              ></div>
              <div className="w-50">
                <MasterComponent allComponentData={allComponentData} />
              </div>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default MobileTaskList;
